var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4998 7L12.8998 11.4C13.2998 11.8 13.2998 12.4 12.8998 12.8L12.7998 12.9C12.3998 13.3 11.7998 13.3 11.3998 12.9L6.9998 8.5L2.5998 12.9C2.1998 13.3 1.59981 13.3 1.19981 12.9L1.0998 12.8C0.699805 12.4 0.699805 11.8 1.0998 11.4L5.4998 7L1.0998 2.6C0.699805 2.2 0.699805 1.60001 1.0998 1.20001L1.19981 1.1C1.59981 0.700003 2.1998 0.700003 2.5998 1.1L6.9998 5.5L11.3998 1.1C11.7998 0.700003 12.3998 0.700003 12.7998 1.1L12.8998 1.20001C13.2998 1.60001 13.2998 2.2 12.8998 2.6L8.4998 7Z",
    fill: "rgba(0, 0, 0, 0.88)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/ic-close.fd923a761ddef03304955da4df60480f.svg";
export { ForwardRef as ReactComponent };